import styled from 'styled-components'

export const Container = styled.div`
  height: 490px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 10px;
`

export const FilterContainer = styled(Container)`
  display: grid;
  width: 680px;
  grid-template-columns: repeat(3, 1fr);
  height: auto;
  padding: 0px;
  margin-bottom: 20px;
  gap: 10px;
`

export const Row = styled(Container)`
  width: 100%;
  flex-direction: row;
  margin-bottom: 10px;
  padding: 0px;
  gap: 10px;
`
